import React from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './_slick-restyle.scss'

const ReviewSlider = ({images, settings}) => {
   const styles = images.length === 1 ? {
      width: 'auto',
   } : null

   return <Slider {...settings}>
      {images.map((image, i) => (
         <div key={image.alt + '_' + i} className='review__item'>
            <img alt={image.alt} src={image.url} title={image.title} style={styles} />
         </div>
      ))}
   </Slider>
}

export default ReviewSlider